var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13",
      "height": "22"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "m0 7.856 9.975 4.987V2.87zM12.025 21.52s-.065-20.496 0-20.568H13V21.52z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }